import { Box, Button, Menu, useTheme } from "@mui/material";
import { FC } from "react";
import { useLocalization } from "../../../../hooks/useLocalization";
import { FilterSelectOption, MENU_ITEM_HEIGHT } from "./FilterSelectOption";
import { FilterSelectOptionList } from "./FilterSelectOptionList";

interface FilterSelectDesktopProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  handleClose: () => void;
  options: Array<{ value: string; label: string }>;
  isAllSelected: boolean;
  handleToggleAll: () => void;
  tempSelectedValues: string[];
  handleToggleOption: (value: string) => void;
  handleCancel: () => void;
  handleApply: () => void;
  menuMaxWidth?: number | string;
}

export const FilterSelectDesktop: FC<FilterSelectDesktopProps> = ({
  anchorEl,
  open,
  handleClose,
  options,
  isAllSelected,
  handleToggleAll,
  tempSelectedValues,
  handleToggleOption,
  handleCancel,
  handleApply,
  menuMaxWidth = 250,
}) => {
  const theme = useTheme();
  const { t } = useLocalization();

  return (
    <Menu
      anchorEl={anchorEl}
      onClose={handleClose}
      open={open}
      slotProps={{
        paper: {
          sx: {
            display: "flex",
            flexDirection: "column",
            maxHeight: 350,
            maxWidth: "calc(100% - 32px)",
            minWidth: 200,
            width: menuMaxWidth,
            overflow: "hidden",
          },
        },
      }}
    >
      {options.length > 0 && (
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <FilterSelectOption
            isSelected={isAllSelected}
            label={t("components.filterSelect.all")}
            onClick={handleToggleAll}
          />
        </Box>
      )}
      <FilterSelectOptionList
        handleToggleOption={handleToggleOption}
        maxHeight={MENU_ITEM_HEIGHT * 8}
        options={options}
        sx={{ flex: 1 }}
        tempSelectedValues={tempSelectedValues}
      />
      <Box
        sx={{
          borderTop: 1,
          borderColor: "divider",
          display: "flex",
          gap: 1,
          justifyContent: "flex-end",
          p: 1,
        }}
      >
        <Button
          onClick={handleCancel}
          size="small"
          sx={{
            color: theme.colors.text[5],
            fontSize: 12,
            width: 60,
          }}
          variant="secondary"
        >
          {t("components.filterSelect.cancel")}
        </Button>
        <Button
          onClick={handleApply}
          size="small"
          sx={{
            backgroundColor: theme.colors.primary[5],
            fontSize: 12,
            minWidth: 60,
            "&:hover": {
              backgroundColor: theme.colors.primary[6],
            },
          }}
          variant="contained"
        >
          {t("components.filterSelect.apply")}
        </Button>
      </Box>
    </Menu>
  );
};
